import type {
  IFileBasedExamGradeDto,
  IFileBasedExamGradeResponse,
} from "./types";
import type { IPathByIdParam } from "./path";

import type { IApiResponse } from "@/api";
import { createGetApi } from "@api/util/createGetApi";
import { createPatchApi } from "@api/util/createPatchApi";

const getApis = createGetApi<
  IApiResponse<IFileBasedExamGradeResponse>,
  IPathByIdParam,
  object
>("courses.exams.fileBased.grades");
const patchApis = createPatchApi<
  IApiResponse<IFileBasedExamGradeResponse>,
  IPathByIdParam,
  IFileBasedExamGradeDto
>("courses.exams.fileBased.grades");

export const grades = {
  ...getApis,
  ...patchApis,
};
